import React, { Fragment } from 'react';
import { Label } from 'reactstrap';
import Modal from './CustomModal';
import ListingDetails from '../components/ListingDetails';
// images
import crossbutton from '../images/icons/cross.svg';
import crossActivebutton from '../images/icons/cross-active.svg';
import open from '../images/icons/opentab.svg';
import openActive from '../images/icons/opentab-active.svg';
import { modalView } from '../components/GoogleAnalytics';
import TopFloatButton from './TopFloatButton';
import { getSizes } from './utils';

class ListingDetailsModal extends React.Component {
    constructor(props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
        this.state = {
            openIconHover: false,
            crossHover: false
        }
    }

    closeModal = () => {
        this.props.toggle('listingDetailsModal');
    }

    toggleModal = (key) => {
        this.setState({ [key]: !this.state[key] })
    }

    componentDidMount() {
        // Register Modal open with Google Analytics
        modalView('listingDetailsModal?listingid=' + this.props.listingId);
    }

    onListingLoaded = (listing) => {
        this.setState({ count: (listing.PublicDocuments && listing.PublicDocuments.length) || 0 });
    }

    render() {
        const { publicPortal } = this.props;
        const { isMobile } = getSizes();
        const showOpenInNewTab = !publicPortal || !isMobile;
        const modalHeader = <div className="listing_buttons_container_modal">
            {showOpenInNewTab && <button className="open" type="button" data-dismiss="modal" aria-label="open"
                onClick={() => window.open(this.props.publicPortal ? `/listing-details/public-portal/${this.props.listingId}` : `/listing-details/${this.props.listingId}`)}
                onMouseEnter={() => this.setState({ openIconHover: true })}
                onMouseLeave={() => this.setState({ openIconHover: false })}>
                <img className="no_background" src={this.state.openIconHover ? openActive : open} alt="open" />
            </button>
            }
            <button className="close" type="button" data-dismiss="modal" aria-label="Close" onClick={() => this.closeModal()}
                onMouseEnter={() => this.setState({ crossHover: true })}
                onMouseLeave={() => this.setState({ crossHover: false })}>
                <img className="no_background" src={this.state.crossHover ? crossActivebutton : crossbutton} alt="close" />
            </button>
        </div>
        return <Fragment>
            <Label id="listingDetailsModal">Listing Details Dialog</Label>
            <Modal modalIsOpen={this.props.modalIsOpen}
                ariaLabelBy="listingDetailsModal"
                className="dyna-modal modal-xxl no-gutters"
                handleClose={() => this.closeModal()}
                customHeader={<div></div>} >
                <ListingDetails
                    history={this.props.history}
                    publicPortal={this.props.publicPortal}
                    settings={this.props.settings}
                    // documentsBar={this.state.documentsBar}
                    // toggleModal={this.toggleModal}
                    listingId={this.props.listingId}
                    listingActions={this.props.listingActions}
                    modalHeader={modalHeader}
                    modalIsOpen={this.props.modalIsOpen}
                    onListingLoaded={this.onListingLoaded}
                    onScrollToSection={(element) => element.scrollIntoView({ behavior: 'smooth', block: 'start' })}
                />
                {this.props.modalIsOpen &&
                    <div
                        className="backToTop"
                    >
                        <TopFloatButton
                            onClick={() =>
                                document.getElementById('listing-details-header')
                                    .scrollIntoView({ behavior: 'smooth', block: 'start' })
                            }
                        />
                    </div>
                }
            </Modal>
        </Fragment>
    }
}

export default ListingDetailsModal